import { useState } from "react";
import { toast } from "sonner";
import { http, login } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const useCheckout = () => {
  const { user } = useAuth();
  const [busy, setBusy] = useState(false);

  const checkout = async (items) => {
    if (!user) {
      toast("Sign in with Google to finish your order", { action: { label: "Sign in", onClick: login } });
      return;
    }
    setBusy(true);
    try {
      const { data } = await http.post("/payments/checkout", { items, origin_url: window.location.origin });
      if (data?.checkout_url) window.location.href = data.checkout_url;
      else throw new Error("no url");
    } catch {
      toast.error("Checkout couldn't open. Please try again.");
      setBusy(false);
    }
  };

  return { checkout, busy };
};
